var EProductPlanPaymentInterval = /*#__PURE__*/ function(EProductPlanPaymentInterval) {
    EProductPlanPaymentInterval["OneTime"] = "oneTime";
    EProductPlanPaymentInterval["Daily"] = "daily";
    EProductPlanPaymentInterval["Monthly"] = "monthly";
    EProductPlanPaymentInterval["Quarterly"] = "quarterly";
    EProductPlanPaymentInterval["HalfYearly"] = "halfYearly";
    EProductPlanPaymentInterval["Yearly"] = "yearly";
    return EProductPlanPaymentInterval;
}(EProductPlanPaymentInterval || {});
var EProductPlanVisibility = /*#__PURE__*/ function(EProductPlanVisibility) {
    EProductPlanVisibility["Public"] = "public";
    EProductPlanVisibility["Private"] = "private";
    return EProductPlanVisibility;
}(EProductPlanVisibility || {});
export { EProductPlanPaymentInterval, EProductPlanVisibility };
